import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { MailCheck } from "lucide-react";
import { PublicHeader, Wordmark } from "../components/PublicHeader";
import { api, formatApiError } from "../lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#f5f3ee]">
      <PublicHeader />
      <div className="pt-16 min-h-screen flex items-center justify-center px-6 py-16">
        <div className="w-full max-w-md bg-white rounded-lg border border-[#e3e0d3] p-8 sm:p-10" data-testid="forgot-password-page">
          <Wordmark />
          {sent ? (
            <div className="mt-8 text-center" data-testid="forgot-password-sent">
              <MailCheck size={38} className="mx-auto text-[#7C8514]" />
              <h1 className="text-xl font-bold text-[#0d2f4d] mt-5">Check your email</h1>
              <p className="text-sm text-[#51637a] mt-2 leading-relaxed">
                If an account exists for <span className="font-medium text-[#0d2f4d]">{email}</span>,
                we've sent a link to reset your password. The link expires in 1 hour.
              </p>
              <Link to="/signin" className="inline-flex mt-7 text-sm text-[#7C8514] font-medium hover:underline" data-testid="back-to-signin">
                Back to sign in
              </Link>
            </div>
          ) : (
            <>
              <h1 className="text-2xl font-bold text-[#0d2f4d] tracking-tight mt-6">Forgot your password?</h1>
              <p className="text-sm text-[#51637a] mt-1">Enter your email and we'll send you a reset link.</p>
              <form onSubmit={submit} className="mt-8 space-y-5">
                <div>
                  <label className="text-xs uppercase tracking-[0.15em] font-medium text-[#51637a]">Email</label>
                  <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                    data-testid="forgot-email-input"
                    className="mt-1.5 w-full rounded-lg border border-[#e3e0d3] px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#94a01a]" />
                </div>
                <button type="submit" disabled={busy} data-testid="forgot-submit-button"
                  className="w-full rounded-full bg-[#0d2f4d] text-white font-medium py-3.5 hover:bg-[#1c4d78] transition-colors disabled:opacity-60">
                  {busy ? "Sending..." : "Send reset link"}
                </button>
              </form>
              <p className="mt-6 text-sm text-[#51637a]">Remembered it? <Link to="/signin" className="text-[#7C8514] font-medium hover:underline">Sign in</Link></p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
